export default {
  state: {
    redeem: {
      show: false
    }
  },
  mutations: {
    setRedeemData (state, data) {
      for (let field in data) {
        state.redeem[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/redeem.js